import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';

export function useGetWorkflowAutomation({ automationId }: { automationId?: string }) {
  const { data, loading, error } = useQuery<
    API.GetAutomationQuery,
    API.GetAutomationQueryVariables
  >(Queries.automation.getAutomation, {
    variables: {
      id: automationId ?? '',
    },
    skip: isNil(automationId),
  });

  return {
    automation: data?.getAutomation,
    loading,
    error,
  };
}
